<template>
	<div class="o-wrap">
		<el-page-header @back="$router.go(-1)" content="选手列表" />
		<el-button class="add-btn" @click="handleAdd(ids)">添加选手</el-button>
		<!-- <el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane :label="`已上线 [${total1}]`" name="1"></el-tab-pane>
			<el-tab-pane :label="`已下线 [${total2}]`" name="2"></el-tab-pane>
		</el-tabs> -->
		<div class="counst">
			<el-table :data="tableData" border>
				<el-table-column fixed prop="title" label="公司名" />
				<el-table-column prop="photo" label="公司logo">
					<template scope="scope">
						<img :src="$store.state.IMG_URL+scope.row.photo" width="40" height="40" class="head_pic" />
					</template>
				</el-table-column>
				<el-table-column prop="contacts" label="联系人" />
				<el-table-column prop="phone" label="联系电话" />
				<el-table-column prop="number_votes" label="投票总数" />
				<!-- <el-table-column label="状态">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.news_is_no" active-color="#13ce66" :active-value="1" :inactive-value="0"
							@change="statusChange(scope.row)" />
					</template>
				</el-table-column> -->
				<el-table-column label="操作">
					<template slot-scope="scope">
						<!-- <el-button type="text" size="small" @click="handleJump(scope.row)">查看</el-button> -->
						<el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
						<el-button type="text" size="small" @click="handleAllShelf(scope.row)"
							v-if="scope.row.state==1">下架</el-button>
						<el-button type="text" size="small" @click="handleAllPut(scope.row)" v-if="scope.row.state==0">
							上架</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background layout="prev, pager, next" :total="total" :page-size="15" hide-on-single-page
				@current-change="currentChange" />
		</div>


	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
				p: 1,
				total: 0,
				a: 1,
				ids: '',
				state: '',
			}
		},
		created() {
			this.ids = this.$route.query.id
			this.getData()

		},
		methods: {
			getData() {
				this.$axios.post('Exhibition-Admin-getVotePlayerList', {
					vote_id: this.ids
				}).then(data => {
					this.tableData = data
				})
			},
			handleEdit(row) {
				this.$router.push(`/player/revise?id=${row.id}`)

			},
			currentChange(page) {
				this.p = page
				this.getData()
			},
			statusChange(row) {
				this.$axios.post('Exhibition-Admin-addVotePlayerInfo', {
					name: 'news_is_no',
					id: row.id,
					value: row.news_is_no
				}).then(data => {
					this.$message({
						type: 'success',
						message: '修改成功'
					})
				})
			},
			handleDel(row) {
				// 删除
				this.$axios.post('Exhibition-Admin-saveFieldInfo', {
					model: 'VotePlayer',
					id: row.id,
					field: "state",
					value: 3
				}).then(data => {
					this.$message({
						type: 'success',
						message: '删除成功'
					})
					this.getData();
				})
			},
			handleAdd(ids) {
				this.$router.push(`/player/release?id=${ids}`)
			},
			handleClick() {
				this.getData()
			},
			handleAllShelf(row) {
				//下架
				this.$axios.post('Exhibition-Admin-saveFieldInfo', {
					id: row.id,
					model: "VotePlayer",
					field: "state",
					value: 0
				}).then(data => {
					this.$message({
						type: 'success',
						message: '修改成功'
					})
					this.getData()
				})
			},
			handleAllPut(row) {
				//上架
				this.$axios.post('Exhibition-Admin-saveFieldInfo', {
					id: row.id,
					model: "VotePlayer",
					field: "state",
					value: 1
				}).then(data => {
					this.$message({
						type: 'success',
						message: '修改成功'
					})
					this.getData()
				})
			},

		}
	}
</script>

<style scoped>
	.el-button+span {
		margin-left: 10px;
	}

	.el-pagination {
		text-align: center;
		margin-top: 20px;
	}
</style>
